import { render } from "./App.vue?vue&type=template&id=842a2958"
const script = {}

import "./App.vue?vue&type=style&index=0&id=842a2958&lang=scss"

import exportComponent from "C:\\PROJEKTE\\GAMES\\dead-technologies\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__